import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11773809"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 출금희망금액 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("출금 가능 금액(수수료포함)")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 남는 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 출금 신청 합니다 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 출금 수수료 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 입금 예정금액 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 입금 받을 본인 계좌 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 계좌변경 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" * 출금 신청 금액은 거래에 사용이 불가능하며, 신청 후 다음 영업일 오후 6시까지 출금 처리됩니다. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 출금 신청 되었어요! ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 다음 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 이전 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 출금신청 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 출금 취소 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 확인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_keypad = _resolveComponent("keypad")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        (_ctx.componentNumber === 1)
          ? (_openBlock(), _createBlock(_component_ag_box_s, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {
          mt:'10px',
          mb:'16px',
          textAlign:'center',
        } }, {
                  default: _withCtx(() => [
                    (!_ctx.withdrawAmount)
                      ? (_openBlock(), _createBlock(_component_ag_text_s, {
                          key: 0,
                          css: {
            dp:'block',
            mb:'20px',
            color:'gray6',
          },
                          class: "price-font"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }))
                      : (_ctx.withdrawAmount)
                        ? (_openBlock(), _createBlock(_component_ag_text_s, {
                            key: 1,
                            class: "price-font",
                            css: {
            dp:'block',
            mb:'20px',
            color: _ctx.withdrawAmount>_ctx.withdrawAvailableAmount?'red2':''
          }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.currency(_ctx.withdrawAmount)), 1),
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["css"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_ag_box_s, { css: {
            dp:'flex',
            direction:'row',
            px:'20px',
            justifyContent:'space-between',
            typography:'text14r',
            marginBottom:'8px',
            color:'gray3',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {
              dp:'flex',
              direction:'row',
              alignItems: 'center',
            } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text_s, null, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.helpCircleOutline,
                              style: {
                width:'20px',
                height:'20px',
              },
                              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'출금 가능 금액', 'clickContent':'출금 가능 금액 툴팁'}); _ctx.openPopover()})
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.withdrawAvailableAmount)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {
            dp:'flex',
            px:'20px',
            justifyContent:'space-between',
            typography:'text14r',
            marginBottom:'8px',
            color:'gray3',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, { css: {
              color:'primary',
            } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.withdrawAvailableAmount-_ctx.withdrawAmount)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_keypad, {
                  "model-value": _ctx.withdrawAmount,
                  type: _ctx.openTypeRef,
                  onWithdrawAll: _ctx.withdrawAll,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputFunc($event)))
                }, null, 8, ["model-value", "type", "onWithdrawAll"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.componentNumber === 2)
          ? (_openBlock(), _createBlock(_component_ag_box_s, {
              key: 1,
              css: {
        dp:'flex',
        direction:'column',
        alignItems:'center',
        textAlign:'center',
        px:'20px',
      }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {
          my:'24px'
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit24r'} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num24eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.withdrawAmount)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit20r'} }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {
          dp:'flex',
          direction:'row',
          justifyContent:'space-between',
          typography:'text14r',
          marginBottom:'8px',
          width:'100%',
          color:'gray3',
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {
            typography:'text16r',
            color:'black',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {
              typography:'num16eb',
            } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(1000)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {
          dp:'flex',
          direction:'row',
          justifyContent:'space-between',
          typography:'text14r',
          marginBottom:'8px',
          width:'100%',
          color:'gray3',
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {
            typography:'text16r',
            color:'primary',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {
              typography:'num16eb',
            } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.withdrawAmount - 1000)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {
          typography:'text14r',
          marginBottom:'8px',
          width:'100%',
          color:'gray3',
          textAlign:'left',
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, null, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {
          dp:'flex',
          direction:'row',
          justifyContent:'space-between',
          typography:'text14r',
          marginBottom:'8px',
          width:'100%',
          color:'gray3',
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {
            textAlign:'left',
            typography:'text16r',
            color:'black',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.bankInfo.bankName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_box_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.bankInfo.bankAccount), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, {
                      css: {
            width: '88px',
            height: '48px',
            border: '1px solid #D9DEE8',
            dp:'flex',
            justifyContent:'center',
            alignItems: 'center',
            borderRadius:'6px',
          },
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createModal('account','refund')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {
          borderRadius:'4px',
          width:'100%',
          color:'primary',
          bg:'#F6F8FB',
          mt:'16px',
          p:'8px',
          typography:'btn12r',
          textAlign:'left'
        } }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.componentNumber === 3)
          ? (_openBlock(), _createBlock(_component_ag_box_s, {
              key: 2,
              css: {
        dp:'flex',
        direction:'column',
        alignItems:'center',
        textAlign:'center',
        px:'20px',
      }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_img, {
                  width: "38px",
                  height: "38px",
                  margin: "20px 0px",
                  src: "/assets/image/small_check.png"
                }),
                _createVNode(_component_ag_box_s, { css: {
          mb:'24px'
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit24r'} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num24eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.withdrawAmount)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit20r', mb:'16px'} }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'text16r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.dueDate) + " 까지 출금 처리됩니다. ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box_s, { css: {
        dp:'flex',
        gap:'sp6'
      } }, {
          default: _withCtx(() => [
            (_ctx.componentNumber === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ag_button, {
                    corner: "10px",
                    outline: "primary",
                    width: "100%",
                    onClickCapture: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`취소`});_ctx.cancel()})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_button, {
                    corner: "10px",
                    disabled: _ctx.checkDisable,
                    width: "100%",
                    onClickCapture: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.checkBankAccountAndGoNext()})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : (_ctx.componentNumber === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_ag_button, {
                      corner: "10px",
                      outline: "primary",
                      width: "100%",
                      onClickCapture: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`이전`});_ctx.previous()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_button, {
                      corner: "10px",
                      disabled: _ctx.checkDisable,
                      width: "100%",
                      onClickCapture: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`출금신청`});_ctx.requestWithdraw()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 64))
                : (_ctx.componentNumber === 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_ag_button, {
                        corner: "10px",
                        outline: "primary",
                        width: "100%",
                        onClickCapture: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`출금 취소`});_ctx.cancelWithdrawConfirm()})
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_button, {
                        corner: "10px",
                        disabled: _ctx.checkDisable,
                        width: "100%",
                        onClickCapture: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`확인`});_ctx.closeModal()})
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ], 64))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}